// 📁 Imports

// 💾 Variables

// 📐 Functions
const getTranslateData = (key) => {
  const lang = window.oConfig.lang || "cz";

  const data = window.oLangs;

  if (!data) return key;

  try {
    if (data?.[lang]?.[key]) {
      return data[lang][key];
    } else {
      return key;
    }
  } catch (error) {
    console.error("Chyba pri parsovaní translationMerlin:", error);
    return key;
  }
};

// 📤 Export
export { getTranslateData };
